<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner home__inner">
          <h1 class="title title_red page__title home__title">Коммуникационное<br> бюро UP</h1>
          <button class="button page__btn" @click="$router.push({ name: 'contacts' })">Написать нам</button>
          <br>
        </div>
      </div>
    </div>

<!--    <div v-if="$isVisibleBg" id="particles" />-->
    <homeSvg />

  </div>
</template>

<script>
// eslint-disable-next-line
// import particlesJS from 'xesjkeee-particles'
// import options from '@/libs/particles.js'
import { TimelineMax, TweenMax } from 'gsap'
import homeSvg from '@/components/homeSvg.vue'
export default {
  name: 'home',
  components:{
    homeSvg
  },
  mounted () {
    // window.particlesJS.load('particles', options)

    new TimelineMax()
      // .add(TweenMax.from('#particles', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.page__btn', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.page__desc', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.home__illustration', 0.6, { y: '-60px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    new TimelineMax()
      .add(TweenMax.to('.page__desc', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__btn', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('#particles', 0.5, { opacity: 0 }))
      .add(TweenMax.to('.home__illustration', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
